import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/AboutUs.css'; // Reuse your existing styles

const ComingSoon = () => {
  return (
    <div className="about-container">
      <section className="intro-section">
        <h1>🚧 Coming Soon</h1>
        <p>We're currently building something exciting and impactful.</p>
        <p>Please check back soon or follow us for updates or</p>
       <p><a href="mailto:konstructcyber@gmail.com" >Contact Us </a>  to help you with it</p> 
      </section>

      <section className="contact-section">
       <Link to="/" className="notfound-link">Go Back Home</Link>
      </section>
    </div>
  );
};

export default ComingSoon;
